module.exports = __webpack_public_path__ + "img/ico-more.09ad9424.svg";